const DATA_ENDPOINT = '/api/v2/livestream/player/';
const LOCATOR_ENDPOINT = '/api/v2/geo/locator/';

export function getPlayer(channel) {
  let args = '';

  if (window.location.search.indexOf('ipOverride') !== -1) {
    args = window.location.search;
  }

  return fetch(`${DATA_ENDPOINT}${channel}/${args}`).then(response => response.json());
}

export default function locate() {
  return fetch(LOCATOR_ENDPOINT)
    .then(response => response.json())
    .then(({ payload }) => {
      return eval(payload)();
    });
}